import { useNavigate } from "react-router-dom"
import { Box, Button, Stack, Typography } from "@mui/material"

export default function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <Box sx={{ py: 10, textAlign: "center" }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h1">Not found</Typography>
        <Typography variant="body2" color="text.secondary">
          That page does not exist, or you no longer have access to it.
        </Typography>
        <Button variant="contained" onClick={() => navigate("/")}>
          Back to the dashboard
        </Button>
      </Stack>
    </Box>
  )
}
